import { render, staticRenderFns } from "./DistributionConfirmModal.vue?vue&type=template&id=41231733"
import script from "./DistributionConfirmModal.vue?vue&type=script&lang=js"
export * from "./DistributionConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports